module.exports = __webpack_public_path__ + "static/teleco_19-d0b6627d7118fc793a2c9d15016badc9.jpg";